export const videoList = [
  {
    id: "video-1",
    type: "video",
    title: "3 分钟看完年度最搞笑的十个综艺名场面",
    excerpt:
      "把一整年的笑声浓缩成三分钟，每一个画面都能让办公室的同事回头看你一眼。建议戴耳机观看。",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20television%20studio%20stage%20with%20warm%20amber%20lights%20and%20playful%20energy%2C%20fun%20variety%20show%20atmosphere%2C%20editorial%20photography%2C%20vibrant%20orange%20and%20gold%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-01&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    category: "搞笑",
    duration: "03:12",
    tags: ["搞笑", "综艺", "合集"],
    author: "我爱搞视频组",
    source: "我爱搞视频",
    publishedAt: "2026-10-13",
    plays: 421300,
    content: [
      "本期我们把过去一年最出圈的综艺名场面剪成一支合集，从翻车瞬间到神级反应应有尽有。",
      "为了让节奏更紧凑，剪辑师把每个片段控制在三到五秒，保证你全程不无聊。",
      "片尾还埋了一个彩蛋，是拍摄时意外录到的花絮，据说比正片还好笑。",
    ],
  },
  {
    id: "video-2",
    type: "video",
    title: "短剧《合租日记》第一集：室友居然是我的新同事",
    excerpt:
      "一次普通的合租，一场尴尬的相遇。当新室友走进办公室的那一刻，故事才真正开始。轻喜剧短剧第一集上线。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20shared%20apartment%20living%20room%20with%20warm%20lamp%20light%20and%20modern%20furniture%2C%20light%20comedy%20drama%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-02&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    category: "短剧",
    duration: "08:45",
    tags: ["短剧", "轻喜剧", "都市"],
    author: "合租日记剧组",
    source: "我爱搞视频",
    publishedAt: "2026-10-12",
    plays: 287650,
    content: [
      "《合租日记》讲述三个性格迥异的年轻人合租同一间房，在鸡毛蒜皮里慢慢成为朋友的故事。",
      "第一集从女主搬家开始，从扛行李箱到认错门牌，笑点密集。直到第二天上班，她才发现昨天的邻居竟是自己部门的新同事。",
      "本剧采用自然光实景拍摄，尽量还原普通年轻人的生活质感，没有夸张的滤镜。",
      "后续剧集每周更新一集，欢迎在评论区催更。",
    ],
  },
  {
    id: "video-3",
    type: "video",
    title: "对话导演：一部电影的声音是怎么做出来的",
    excerpt:
      "我们请到《雾中回声》的声音团队，聊了聊如何用声音讲一个悬疑故事。原来一场雨，可能录了整整三天。",
    cover:
      "https://readdy.ai/api/search-image?query=professional%20sound%20recording%20studio%20with%20warm%20amber%20lighting%20and%20microphone%20boom%2C%20cinematic%20interview%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20slate%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-03&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    category: "访谈",
    duration: "12:30",
    tags: ["访谈", "幕后", "电影"],
    author: "我爱搞访谈室",
    source: "我爱搞视频",
    publishedAt: "2026-10-11",
    plays: 156420,
    content: [
      "本期访谈邀请到电影《雾中回声》的声音团队，分享他们如何用声音营造悬疑氛围。",
      "声音指导透露，片中一场雨戏的环境音其实录制了三天，只为找到那种恰到好处的潮湿感。",
      "团队还演示了拟音的过程，用一把芹菜模拟骨折、用锡纸模拟火焰，让人大开眼界。",
      "如果你也对电影幕后感兴趣，这期节目值得完整看完。",
    ],
  },
  {
    id: "video-4",
    type: "video",
    title: "挑战！用 100 元预算拍出一支氛围感短片",
    excerpt:
      "一百块钱、一台手机、一个下午，能拍出什么？我们把预算压到极限，最后的结果连自己都惊了。",
    cover:
      "https://readdy.ai/api/search-image?query=low%20budget%20filmmaking%20with%20smartphone%20on%20tripod%20at%20golden%20hour%2C%20creative%20challenge%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20coral%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-04&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    category: "搞笑",
    duration: "06:18",
    tags: ["挑战", "摄影", "创意"],
    author: "穷拍小分队",
    source: "我爱搞视频",
    publishedAt: "2026-10-10",
    plays: 198340,
    content: [
      "规则很简单：预算一百元，道具只能用现场能随手找到的东西，拍摄时间不超过一个下午。",
      "我们没有买任何设备，一块床单当柔光布，一盆水当情绪道具，路边的落叶成了天然布景。",
      "成片出来后，团队自己都惊讶：原来氛围感真的不完全取决于预算，而取决于你有没有用心观察光。",
      "视频最后附上了拍摄花絮和参数设置，想尝试的朋友可以照着做。",
    ],
  },
  {
    id: "video-5",
    type: "video",
    title: "音乐现场：人气乐队不插电专场高能片段",
    excerpt:
      "一支人气乐队的近距离不插电演出，没有多余修饰，只有吉他和声音。现场观众全程大合唱，气氛拉满。",
    cover:
      "https://readdy.ai/api/search-image?query=intimate%20acoustic%20band%20performance%20with%20warm%20amber%20stage%20lighting%20and%20guitars%2C%20cozy%20live%20music%20atmosphere%2C%20editorial%20photography%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-05&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    category: "访谈",
    duration: "15:02",
    tags: ["音乐", "现场", "不插电"],
    author: "我爱搞音乐",
    source: "我爱搞视频",
    publishedAt: "2026-10-09",
    plays: 176920,
    content: [
      "这场不插电专场在一间小剧场举行，观众与乐队的距离不到五米，几乎能听见琴弦的震动。",
      "乐队临时改变了原有的编曲，把几首代表作改成更安静的版本，反而让歌词的情感更加突出。",
      "当主唱唱到副歌时，全场自发地跟着合唱，那一刻没有镁光灯，只有声音和彼此。",
      "完整版已在平台上发布，喜欢这个版本的朋友可以去听。",
    ],
  },
  {
    id: "video-6",
    type: "video",
    title: "街头采访：你今年笑得最开心的一次是什么时候",
    excerpt:
      "我们在街头随机问了一百个人同一个问题。答案五花八门，却在最后让所有人都安静了几秒。",
    cover:
      "https://readdy.ai/api/search-image?query=friendly%20street%20interview%20scene%20with%20warm%20afternoon%20light%20and%20city%20background%2C%20heartwarming%20documentary%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20and%20neutral%20tones%2C%20clean%20composition&width=800&height=600&seq=video-cover-06&orientation=landscape",
    videoUrl: "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    category: "访谈",
    duration: "09:27",
    tags: ["街头采访", "温暖", "生活"],
    author: "我爱搞街采组",
    source: "我爱搞视频",
    publishedAt: "2026-10-08",
    plays: 143280,
    content: [
      "这次我们在街头问了同一个问题：你今年笑得最开心的一次是什么时候？",
      "有人说是在拿到录取通知书的那天，有人说是孩子第一次叫爸爸，还有人想了想，说已经记不清了。",
      "最后一个回答来自一位外卖小哥，他说是昨天，有个顾客在备注里写了一句谢谢，那一刻他笑了。",
      "视频发布后，评论区变成了故事接龙，很多人分享了自己的那个瞬间。",
    ],
  },
];